import * as React from "react";

function ArrowLeftIcon(props) {
	return (
		<svg viewBox="0 0 24 24" fill="none" width="24" height="24" {...props}>
			<path
				d="M15 6L9 12L15 18"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default ArrowLeftIcon;
